/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderListReq: order.OrderListReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.IPage<order.EsOrderInfo>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/orders`,
    data: orderListReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
